import { render, staticRenderFns } from "./LoginSignup.vue?vue&type=template&id=9546d9f8&scoped=true&"
import script from "./LoginSignup.vue?vue&type=script&lang=ts&"
export * from "./LoginSignup.vue?vue&type=script&lang=ts&"
import style0 from "./LoginSignup.vue?vue&type=style&index=0&id=9546d9f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9546d9f8",
  null
  
)

export default component.exports